import styled from 'styled-components';

export const AddToQuickOrderWrapper = styled.div`
  margin: auto 0;
`;
